export function parseSurfaceArea(blocks) {
  const surfaceArea = {};
  for (let block of blocks) {
    let submatrix = block['Surface Area'];
    if (!submatrix) continue;
    for (let row of submatrix) {
      if (row[0] && row[1]) {
        surfaceArea[row[0]] = row[1];
      }
    }
  }
  return surfaceArea;
}
